import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';

@Injectable({
  providedIn: 'root'
})
export class Sh10Service {

  constructor(private httpService: HttpService) { }
////first add
    sh10service(sh10value) {
        console.log("sh10value sh10 web", sh10value);
        var request={
            URL: "sh10/sh10record",
            DATA : sh10value,
        }
        return this.httpService.post(request);
    }

///list
    getsh10details(){
        var registerList = {
            URL: "sh10/getDetails/5cee33d225242e023acfb2d4"
    }
    return this.httpService.get(registerList);
    }

    getModifySearchData(object)
    {
        var registerList = {
            URL: "sh10/getSearchDetails",
            DATA: object
        }
        return this.httpService.post(registerList);
    }

    ////list remove
    removesh10details(_id){
        var request = {
            URL: "sh10/deletadetails/" + _id
        }
        return this.httpService.get(request);

    
    }


    ////on edit update
    updateeditsh10(object, _id) {
        var request = {
            URL: "sh10/updateeditsh10/" +_id,
            DATA: object
        }
        return this.httpService.post(request);
    }

////on fetch for edit into form 
    getupdatesh10(_id) {
        var editlist = {
            URL: "sh10/update/" + _id,
        }
        return this.httpService.get(editlist);
    }

    addrowdetailsh10(depositorObjects){
        var request = {
            URL: 'sh10/addrowdetailsh10',
            DATA: depositorObjects
        }
        return this.httpService.post(request);
    }
    editrowdetailsh10(editData)
    {
        var request = {
            URL: 'sh10/editrowdetailsh10',
            DATA: editData
        }
        return this.httpService.post(request);
    }

    deleteShareAndSecurityDetails(_id, Id) {
        var request = {
            URL: "sh10/deleteShareAndSecurityDetails/" + _id + "/"+Id,
        }
        return this.httpService.get(request);
    }

    getsh10listdata(_id) { 
        var request = {
            URL: "sh10/depositorlist/" + _id
        }
        return this.httpService.get(request);
    }
    update(_id, data){
          var request = {
        URL: "sh10/depositor-details/" + _id,
        DATA: data
        }
        return this.httpService.post(request);
    }


    getsh10detail() {
        var request = {
                URL: "sh10/getDepositorDetails/5cee33d225242e023acfb2d4",
               
        }
        return this.httpService.get(request);
       
    }
    getDepositorDetail() {
        var request = {
                URL: "sh10/getDepositorDetails/:id",
               
        }
        return this.httpService.get(request);
       
    }
    removedetails(_id) {
            var request = {
                URL: "sh10/deleteDepositor/" + _id
            }
            return this.httpService.get(request);
    }

    generateSh10Document(object) {
        var request = {
            URL: "sh10/generateSh10Document",
            DATA: object
        }
        return this.httpService.post(request);
    }

    downloadSh10File(id, type) {
        var token = localStorage.getItem('token')
        window.location.href = environment.pssServerUrl + "sh10/downloadDocument/" + id + "/" + type + "/" + token;
    }

    downloadSh10PdfFile(id, type) {
        var token = localStorage.getItem('token')
        window.location.href = environment.pssServerUrl + "sh10/downloadPdfDocument/" + id + "/" + type + "/" + token;
    }

}